import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Optional,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBasicDirective } from '../input-basic.directive';
import { ISelectOption } from '../select/select.component';

@Component({
  selector: 'lib-select-scrollable',
  templateUrl: './select-scrollable.component.html',
  styleUrls: ['./select-scrollable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectScrollableComponent),
      multi: true,
    },
  ],
})
export class SelectScrollableComponent extends InputBasicDirective<string> implements OnInit, ControlValueAccessor {
  @Input() placeholder = ' ';
  @Input() options: ISelectOption[] = [];
  @Input() value?: string = null;

  public isOpen = false;

  @ViewChild('trigger') private triggerRef?: ElementRef<HTMLButtonElement>;

  constructor(
    @Optional() controlContainer: ControlContainer,
    private elementRef: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef,
  ) {
    super(controlContainer);
  }

  ngOnInit() {
    super.ngOnInit();

    const isValueNullOrUndefined = this.value === null || this.value === undefined;
    if (isValueNullOrUndefined) return;

    this.setInitialValue();
  }

  setInitialValue() {
    this._value$.next(this.value);
  }

  writeValue(value: string) {
    this._value$.next(value ? value + '' : '');
  }

  getLabelForValue(value: string): string {
    return this.options.find((option) => option.value === value)?.label ?? '';
  }

  toggle(): void {
    if (this.completed || this._disabled$.getValue()) {
      return;
    }
    this.isOpen = !this.isOpen;
  }

  selectOption(event: MouseEvent, option: ISelectOption): void {
    event.preventDefault();

    if (this._disabled$.getValue()) {
      return;
    }
    this._value$.next(option.value);
    this.onChange(option.value);
    this.isOpen = false;
    this.onBlur(event);
  }

  closePanel(): void {
    this.isOpen = false;
    this.triggerRef?.nativeElement.blur();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.closePanel();
      this.cdr.markForCheck();
    }
  }
}
